import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AttachEmailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"attach_email"}/>
}
